import { keyframes } from "@mui/system";

export const rotate360 = keyframes`
  0%   { transform: rotate(360deg); }
  100% { transform: rotate(0); }
`;

/**
 * Colours match the semantic palette of the theme (success/error/warning/info).
 * `color` paints the dot and the tint; `onLight`/`onDark` are the label colours,
 * because a single mid-tone hue cannot clear 4.5:1 on both surfaces.
 */
export const statusMeta = {
  completed: {
    label: "Completed",
    color: "#17A673",
    onLight: "#0C7951",
    onDark: "#5DD5A6",
    icon: "✅",
  },
  canceled: {
    label: "Canceled",
    color: "#E5484D",
    onLight: "#B72D32",
    onDark: "#FF7A7E",
    icon: "❌",
  },
  created: {
    label: "Created",
    color: "#F5A524",
    onLight: "#8A5700",
    onDark: "#FFC967",
    icon: "🕓",
  },
  dispute: {
    label: "Dispute",
    color: "#3E8BF3",
    onLight: "#2869C1",
    onDark: "#77B0FF",
    icon: "⚖️",
  },
  form_opened: {
    label: "Form opened",
    color: "#F5A524",
    onLight: "#8A5700",
    onDark: "#FFC967",
    icon: "🕓",
  },
  processing: {
    label: "Processing",
    color: "#F5A524",
    onLight: "#8A5700",
    onDark: "#FFC967",
    icon: "🕓",
  },
  confirmation: {
    label: "Confirmation",
    color: "#F5A524",
    onLight: "#8A5700",
    onDark: "#FFC967",
    icon: "🕓",
  },
};

const unknownStatus = {
  label: "Unknown",
  color: "#667085",
  onLight: "#475467",
  onDark: "#AAB3CA",
  icon: "•",
};

/**
 * Safe lookup: the backend may return a status missing from the dictionary.
 * Pass the palette mode to get a label colour that is readable on that surface.
 */
export const getStatusMeta = (status, mode = "light") => {
  const meta =
    (status && statusMeta[status]) || { ...unknownStatus, label: status || "—" };
  return {
    ...meta,
    textColor: mode === "dark" ? meta.onDark : meta.onLight,
  };
};

/** Human labels for operation types, shared by rates and transactions. */
export const operationLabels = {
  deposit: "Deposit",
  payout: "Payout",
  cashin: "Cash-in",
  withdrawal: "Withdrawal",
  transfer: "Transfer",
};

export const formatDateTime = (value) => {
  const date = new Date(value);
  return {
    date: date.toLocaleDateString("en-GB"),
    time: date.toLocaleTimeString("en-GB", { hour12: false }),
  };
};
